(function () {
    'use strict';

    angular.module('app').factory('CouponsService', CouponsService);

    CouponsService.$inject = ['$rootScope', 'API', 'NotifyService'];

    function CouponsService($rootScope, API, NotifyService) {
        var service = {};
        /**
         * This callback type is called `requestCallback` and is displayed as a global symbol.
         *
         * @callback requestCallback
         * @param {boolean} success
         * @param {Object} data
         */
        /**
         * @typedef MultiLanguageObject
         * @type {Object}
         * @property {string} en - String on English
         * @property {string} pl - String on Polish
         * @property {string} ru - String on Russian
         * @property {string} uk - String on Ukrainian
         */


        var _req_gc = ['COUPONS_BATCHES'];

        initVars();

        function initVars() {
            for (var i in _req_gc)
                $rootScope[_req_gc[i]] = {};
        }

        $rootScope.$on('user-login', function () {
            initVars();
        });

        $rootScope.$on('user-register', function () {
            initVars();
        });

        $rootScope.$on('user-logout', function () {
            for (var i in _req_gc)
                $rootScope[_req_gc[i]] = null;
        });

        service.Batches = function (params, callback) {
            API.get('/coupons/batches?{0}'.format(paramsToUrlQueryEncodeURIComponent(params)), function (success, response) {
                callback(success, response);
            });
        };

        service.BatchesExchange = function (params, callback) {
            API.get('/coupons/exchange?{0}'.format(paramsToUrlQueryEncodeURIComponent(params)), function (success, response) {
                if (success) {
                }
                callback(success, response);
            });
        };

        /**
         * Return all coupons list
         *
         * @param {{sort_field: string, count: number, page: number, sort_order: string, coupon_status: string}} params - Parameters filter
         * @param {number} params.page - List page number
         * @param {number} params.count - Count of codes on page
         * @param {string} params.sort_field -
         * @param {'asc'|'desc'} params.sort_order -
         * @param {string} params.loyalty_id - Loyalty ID
         * @param {string} params.batch_id -
         * @param {string} params.emitter_batch_id -
         * @param {string} params.customer_phone -
         * @param {string} params.customer_external_id -
         * @param {string} params.customer_email -
         * @param {'all'|'open'|'redeemed'|'cancelled'} params.coupon_status -
         * @param {'all'|'yes'|'no'} params.coupon_expired -
         * @param {'all'|'yes'|'no'} params.coupon_deleted -
         * @param {'all'|'yes'|'no'} params.coupon_added_to_wallet -
         * @param {string} params.customer_id_value -
         * @param {'phone'} params.customer_id_type -
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.Coupons = function (params, callback) {
            API.post('/coupons', params, function (success, response) {
                callback(success, response);
            });
        };

        /**
         * Return external coupon batch external codes list
         *
         * @param {string} id - Coupon batch ID
         * @param {Object} params - Parameters filter
         * @param {number} params.page - List page number
         * @param {number} params.count - Count of codes on page
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.ExternalCodes = function (id, params, callback) {
            API.get('/coupons/batch/{0}/external_codes?{1}'.format(id, paramsToUrlQueryEncodeURIComponent(params)), function (success, data) {
                callback(success, data);
            });
        };

        service.ExternalCodesDelete = function (id, post_data, callback) {
            API.post('/coupons/batch/{0}/external_codes/delete'.format(id), post_data, function (success, response) {
                if (success) {

                }
                callback(success, response);
            });
        };

        service.Batch = function (id, callback) {
            API.get('/coupons/batch/' + id, function (success, data) {
                if (success) {
                }
                callback(success, data);
            });
        };

        service.CreateBatch = function (post_data, callback) {
            API.post('/coupons/batches', post_data, function (success, data) {
                if (success) {
                    NotifyService.Success(data.message, false);

                    if ($rootScope.COUPONS_BATCHES[data.loyalty_id] && $rootScope.COUPONS_BATCHES[data.loyalty_id].data)
                        updateItemInList($rootScope.COUPONS_BATCHES[data.loyalty_id].data, data);
                }
                callback(success, data);
            });
        };

        service.ChangeBatch = function (id, post_data, callback) {
            API.patch('/coupons/batch/' + id, post_data, function (success, data) {
                if (success) {
                    NotifyService.Success(data.message, false);

                    if ($rootScope.COUPONS_BATCHES[data.loyalty_id] && $rootScope.COUPONS_BATCHES[data.loyalty_id].data)
                        updateItemInList($rootScope.COUPONS_BATCHES[data.loyalty_id].data, data);
                }
                callback(success, data);
            });
        };

        service.GenerateCoupons = function (batch_id, params, callback) {
            API.get('/coupons/batch/' + batch_id + '/emission?{0}'.format(paramsToUrlQueryEncodeURIComponent(params)), function (success, data) {
                if (success) {
                }
                callback(success, data);
            });
        };

        service.ImportExternalCoupons = function (batch_id, post_data, callback) {
            API.post('/coupons/batch/' + batch_id + '/external_codes/add', post_data, function (success, data) {
                if (success) {
                }
                callback(success, data);
            });
        };

        service.CancelBatch = function (batch_id, params, callback) {
            API.get('/coupons/batch/' + batch_id + '/cancel?{0}'.format(paramsToUrlQueryEncodeURIComponent(params)), function (success, data) {
                if (success) {
                }
                callback(success, data);
            });
        };

        service.CancelBatchCoupons = function (id, callback) {
            API.get('/coupons/batch/' + id + '/coupons/cancel', function (success, data) {
                if (success) {
                }
                callback(success, data);
            });
        };

        service.UploadPhoto = function (id, data, callback) {
            API.postImage('/coupons/batch/' + id + '/photo', data, function (success, response) {
                callback(success, response);
            });
        };

        // service.GiveCouponToCustomers = function (data, callback) {
        //     API.post('/coupons/emit_coupons_to_customers', data, callback);
        // };

        /**
         * Send (emit if needed) batch coupons to the customers
         *
         // * @param {string} batchId - Coupon batch ID.
         * @param {object} data - Post data
         * @param {string} data.comment  - Message text (if empty or null send standard text from brand templates) ,
         * @param {boolean} data.emit_new_coupons  -Emit new coupons end send it ,
         * @param {boolean} data.skip_message - Skip sending notification message ,
         * @param {array} data.users - Skip sending notification message ,
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.GiveCouponToCustomers = function (data, callback) {
            var batchId = data.batch_id;
            API.post('/coupons/batch/' + batchId + '/coupons/send', data, callback);
        };

        service.GetCoupon = function (coupon_id, callback) {
            API.get('/coupons/coupon/' + coupon_id, function (success, data) {
                if (success) {
                }
                callback(success, data);
            });
        };

        service.CancelCoupon = function (batch_id, callback) {
            API.get('/coupons/coupon/' + batch_id + '/cancel', function (success, data) {
                if (success) {
                }
                callback(success, data);
            });
        };

        /**
         * Return list of coupon's customer users ids
         */
        service.AllIds = function (params, callback) {
            API.post('/coupons/customers_bulk_ids', params, function (success, data) {
                callback(success, data);
            });
        };


        service.GerCouponLinks = function (batch_id, callback) {
            API.get('/coupons/batch/' + batch_id + '/links', function (success, data) {
                callback(success, data);
            });
        };

        service.ChangeCouponLinks = function (batch_id, post_data, callback) {
            API.patch('/coupons/batch/' + batch_id + '/links', post_data, function (success, data) {
                callback(success, data);
            });
        };

        service.GetCouponAliases = function (batch_id, params, callback) {
            API.get(('/coupons/batch/' + batch_id + '/aliases?{0}').format(paramsToUrlQueryEncodeURIComponent(params)), function (success, data) {
                callback(success, data);
            });
        };

        service.GetCouponAliasById = function (alias_id, callback) {
            API.get('/coupons/batches/aliases/' + alias_id, function (success, data) {
                callback(success, data);
            });
        };

        service.AddCouponAlias = function (batch_id, post_data, callback) {
            post_data.slow_request = true;
            API.post('/coupons/batch/' + batch_id + '/aliases/add', post_data, function (success, data) {
                callback(success, data);
            });
        };

        service.ChangeCouponAlias = function (alias_id, post_data, callback) {
            API.patch('/coupons/batches/aliases/' + alias_id, post_data, function (success, data) {
                callback(success, data);
            });
        };

        service.findCouponAliases = function (params, callback) {
            API.post('/coupons/batches/aliases', params, function (success, response) {
                callback(success, response);
            });
        };


        return service;
    }

})();
